export default __webpack_public_path__ + "static/media/work5.b6d8a094.png";